import React from 'react';
import type { V2Route } from '../units/types';

const OrgMembersPage = React.lazy(() => import('./OrgMembersPage'));

/** この担当が新UIで作り直した画面の経路。作り終えたものから足す（足すまでは旧画面が枠の中に出る） */
const routes: V2Route[] = [
  { path: 'account/settings', Component: React.lazy(() => import('./AccountSettingsPage')) },
  { path: 'organization/edit', Component: React.lazy(() => import('./OrgManagePage')) },
  // 旧画面は /organization と members・settings・analytics のどれも同じ画面を出していた
  { path: 'organization', Component: OrgMembersPage },
  { path: 'organization/members', Component: OrgMembersPage },
  { path: 'organization/settings', Component: OrgMembersPage },
  { path: 'organization/analytics', Component: OrgMembersPage },
  { path: 'ai-score', Component: React.lazy(() => import('./AiScorePage')) },
];

export default routes;
